import axios from 'axios'
import QS from 'qs'
import { Loading } from 'element-ui'
import wmsMessage from '@/utils/message'
import store from '@/store'
import router from '@/router'
import { baseURL } from '@/const/env'
import gray from '@sniff/gray'

import codeLang from '@/i18n/code'
import { t } from '@/i18n/index'
const graify = gray(baseURL())

// const graify = gray(baseURL())

const service = axios.create({
  baseURL: baseURL(),
  timeout: 180000
  // headers: {'X-Custom-Header': 'foobar'}
})

/****** request 拦截器 ==> 对请求参数做处理 ******/
const loading = {
  num: 0,
  data: null,
  open: function () {
    this.num += 1
    if (!this.data) {
      this.data = Loading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
  },
  close: function () {
    this.num -= 1
    if (this.num <= 0) {
      this.data?.close()
      this.data = null
    }
  }
}
/**
 * 复用 WMS 的版本检查、遮罩、鉴权和灰度处理。
 * @param {import('axios').AxiosRequestConfig} config 当前请求配置。
 * @param {string} [requestUrl=config.url] 鉴权判断地址，生成客户端可传入包含服务前缀的地址。
 */
export const handleRequest = async (config, requestUrl = config.url) => {
  console.log('config',config)
  // 当前页面缓存的版本信息。
  const curVersion = window.curVersion ?? {}
  if (curVersion.time + 10 * 60 * 1000 > Date.now()) {
    // 1:client 2:system 3:wms
  } else {
    // res 为版本查询响应，继续按原规则检查是否刷新页面。
    axiosV.post('/customer/getClientVersion?project=3', {}).then((res) => {
      if (!curVersion.version) {
        //
      } else if (curVersion.version !== res.data.data) {
        // 在下一帧刷新已过期的页面版本。
        requestAnimationFrame(() => {
          location.reload()
        })
      }
      curVersion.version = res.data.data
      curVersion.time = Date.now()
      window.curVersion = curVersion
    })
  }
  // 请求体中的 noMask 控制是否显示现有全局遮罩。
  const params = config.data || {}
  console.log('params', params)
  if(!params.noMask) {
    loading.open()
  }
  // 从现有 Vuex getter 获取登录令牌。
  const _token = store.getters.getToken
  // 登录接口免令牌校验；旧请求默认使用原始 config.url。
  const isAuth = requestUrl.indexOf('/customer/users/token') >= 0
  config.headers['X-GRAY-TAG'] = process.env.VUE_APP_TAG
  if (!isAuth && !!_token) {
    config.headers['X-AuthToken'] = _token
  } else if (!isAuth && !_token) {
    wmsMessage.error(t('未登录'))
    // 按原有延迟清理登录、菜单和基础数据，再进入登录页。
    setTimeout(async () => {
      await store.dispatch('auth/removeAuth')
      await store.dispatch('menu/removeMenu')
      await store.dispatch('baseData/removeRegionList')
      await router.push('/auth')
    }, 200)
  }
  await graify(config)
  // console.log(config)
  return config
}

/** 处理请求发送前的错误；error 为原始错误，保留旧请求的处理行为。 */
export const handleRequestError = (error) => {
  //请求错误处理
  loading.close()
  wmsMessage.error(error)
  Promise.reject(error)
}

service.interceptors.request.use(handleRequest, handleRequestError)

/****** response 拦截器==> 对响应做处理 ******/
/**
 * 创建共享响应拦截器，旧调用默认保持既有返回结构。
 * @param {boolean} [includeResponse=false] 生成客户端需保留 Axios 响应，由其 request 方法解包一次。
 */
export const getHandleResponse = (includeResponse = false) => {
  /** 处理 response 中的业务提示、登录失效和遮罩关闭。 */
  return (response) => {
    //成功请求到数据
    loading.close()
    // 旧请求返回的业务对象继续将字符串状态码转为数字。
    let _data = {}
    //这里根据后端提供的数据进行对应的处理
    if (response.data.code) {
      if (parseInt(response.data.code) !== 0) {
        // 0 为正常
        // console.log(response.data.code)
        _data = {
          ...response.data,
          code: parseInt(response.data.code)
        }

        if (parseInt(response.data.code) != '26010019' && parseInt(response.data.code) != '26000011' && response.data.code != "24010063") {
          // 读取当前语言，沿用现有业务错误翻译规则。
          const lang = localStorage.getItem('lang') ?? 'ja'
          wmsMessage.error(lang === 'ja' ? codeLang[lang][response.data.code] ?? t(response.data.msg) : response.data.msg);
        }
        if (response.data.code == '10000000' || response.data.msg == '用户token过期' || response.data.code == "24010063") {
          // 登录失效后沿用原有延迟清理和跳转流程。
          setTimeout(async () => {
            await store.dispatch('auth/removeAuth')
            await store.dispatch('menu/removeMenu')
            await store.dispatch('baseData/removeRegionList')
            await router.push('/auth')
          }, 200)
        }
      } else {
        _data = {
          ...response.data,
          code: parseInt(response.data.code)
        }
      }
      // TS 客户端保留后端响应字段和类型，避免被其 response.data 再次拆包。
      return Promise.resolve(includeResponse ? response : _data)
    } else {
      return Promise.resolve(response)
    }
  }
}

/** 处理网络响应错误；error 为原始错误，继续提示并拒绝当前请求。 */
export const handleResponseError = (error) => {
  //响应错误处理
  loading.close()
  // console.log(error)
  // 保留原始响应和错误描述，便于现有调试代码使用。
  const { response, message, name } = error
  // console.log('netWork-response', JSON.stringify(response))
  // console.log('netWork-message', message)
  // console.log('netWork-name', name)
  wmsMessage.error('网络异常，请重试')
  return Promise.reject(error)
}

service.interceptors.response.use(getHandleResponse(), handleResponseError)

export const get = function (url, params, config) {
  let uri = url
  if (params) {
    uri = Object.keys(params).reduce((pre, item, array) => {
      const flag = params[item] === '' || params[item] === null
      return flag ? pre : pre + `${item}=${params[item]}&`
    }, `${url}?`)
  }
  return service.get(uri, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const getFrom = function (url, params, config) {
  return service.get(url, {
    params,
    paramsSerializer: function (params) {
      return QS.stringify(params, { arrayFormat: 'comma' })
    }
  })
}

export const post = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const post_OSS = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const post_query = function (url, params, config) {
  let uri = url + '?' + QS.stringify(params, { arrayFormat: 'comma' })
  return service.post(uri, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const put = function (url, params, config) {
  // console.log(url, params)
  return service.put(url, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const post_blob = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    responseType: 'blob'
  })
}
export const post_arraybuffer = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    responseType: 'arraybuffer'
  })
}

const axiosV = axios.create({
  timeout: 3 * 60 * 1000,
  baseURL: baseURL()
})
